import styled from 'styled-components';
import { req } from '../../@api/request';
import { s } from './pay.style';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { start } from 'repl';
import dayjs from 'dayjs';
import CouponModal from './CouponModal';
import CouponService from '../../service/coupon/Coupon';
import { PageContainer } from '../components/common/PageComponent.style';

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
  P_NOTI_URL: string;
  P_VBANK_DT?: string;
}

export interface Coupon {
  name: string;
  use_time: string;
  membership: string;
  description: string;
  expire_time: string;
  is_possible: boolean;
  payment_price: number;
  coupon_history_id: number;
}

const PaymentMethod = () => {
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const location = useLocation();
  const { selectedPlan, month } = location.state || {};
  const isDiscount = selectedPlan?.is_discount === 'Y';
  const [formData, setFormData] = useState<IFormData>();
  const formRef = useRef<HTMLFormElement>(null);
  const [data, setData] = useState<any>(null);
  const [paymentType, setPaymentType] = useState<'CARD' | 'BANK' | 'VBANK'>(
    'CARD',
  );
  const [selectedCoupon, setSelectedCoupon] = useState<Coupon | null>(null);
  const [maxDiscountCoupon, setMaxDiscountCoupon] = useState<Coupon | null>(
    null,
  );
  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
  const [couponList, setCouponList] = useState<Coupon[]>([]);
  const [couponTotalCount, setCouponTotalCount] = useState(0);

  const buttonRef = useRef<HTMLDivElement>(null);

  const [isFixed, setIsFixed] = useState(true);
  const [formattedStart, setFormattedStart] = useState('');
  const [formattedEnd, setFormattedEnd] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsFixed(false);
        } else {
          setIsFixed(true);
        }
      },
      { threshold: 0.5 },
    );

    if (buttonRef.current) observer.observe(buttonRef.current);
    return () => observer.disconnect();
  }, []);

  // yyyy년 MM월 dd일 형식으로 포맷팅
  const formatDate = (date: Date) => {
    return `${date.getFullYear()}년 ${String(date.getMonth() + 1).padStart(2, '0')}월 ${String(date.getDate()).padStart(2, '0')}일`;
  };

  const addMonthsSafe = (date: Date, months: number) => {
    const d = new Date(date);
    const day = d.getDate();
    d.setMonth(d.getMonth() + months);
    // 말일 처리 보정
    if (d.getDate() !== day) {
      d.setDate(0);
    }
    return d;
  };

  const extractExtensionMonths = (name?: string) => {
    if (!name) return 0;
    const m = name.match(/(\d+)\s*개월.*연장/);
    return m ? parseInt(m[1], 10) : 0;
  };

  useEffect(() => {
    const plan_end = localStorage.getItem('plan_end');
    const startDate =
      plan_end && plan_end !== 'null' ? new Date(plan_end) : new Date();
    const endDate = new Date(startDate);
    const extraMonth =
      selectedPlan?.name?.includes('바른NPL') ||
      selectedPlan?.name?.includes('공인중개사')
        ? 3
        : 0;

    if ((month || 1) === 12) {
      endDate.setDate(endDate.getDate() + 365 + 30 * extraMonth);
    } else {
      endDate.setDate(endDate.getDate() + 30 * ((month || 1) + extraMonth));
    }

    const extendMonths = extractExtensionMonths(selectedCoupon?.name);
    const finalEndDate =
      extendMonths > 0 ? addMonthsSafe(endDate, extendMonths) : endDate;

    setFormattedStart(formatDate(startDate));
    setFormattedEnd(formatDate(finalEndDate));
  }, [selectedPlan, month, selectedCoupon]);

  const getCouponList = async () => {
    try {
      const res = await CouponService.list('A', 1, 'B', selectedPlan.plan_id);
      setCouponTotalCount(res.data.totalCount);
      setCouponList(res.data.list);
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePayment = async (paymentType: 'CARD' | 'BANK' | 'VBANK' | '') => {
    if (!selectedPlan.plan_id) {
      alert('결제할 상품을 선택해주세요.');
      return;
    }

    if (!paymentType) {
      alert('결제할 수단을 선택해주세요.');
      return;
    }

    try {
      const paymentTypes = {
        CARD: 'C',
        BANK: 'D',
        VBANK: 'V',
      };

      const res = await req.get(
        `payment/${selectedPlan.plan_id}?paymentType=${paymentTypes[paymentType]}&coupon_history_id=${selectedCoupon?.coupon_history_id}`,
      );
      setFormData({
        P_INI_PAYMENT: paymentType,
        P_MID: res.data.data.mid,
        P_OID: res.data.data.oid,
        P_AMT: res.data.data.price,
        // P_AMT: selectedPlan.plan_prc,
        P_GOODS: res.data.data.goodname,
        P_UNAME: res.data.data.userName,
        P_NEXT_URL: `${server}/payment/auth/phone?front=${window.location.origin}&userId=${res.data.data.userId}&loginType=${res.data.data.loginType}&planId=${selectedPlan.plan_id}&paymentType=${paymentTypes[paymentType]}&userKey=${res.data.data.userKey}&coupon_history_id=${res.data.data.coupon_history_id}}`,
        P_RESERVED: 'centerCd=Y',
        url: 'https://mobile.inicis.com/smart/payment/',
        P_NOTI_URL: `${server}/payment/noti/mobile`,
        P_VBANK_DT: dayjs().add(3, 'day').format('YYYYMMDD'),
      });
    } catch (error: any) {
      console.error(error.response.data.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (formData && formRef.current) {
      formRef.current.submit();
    }
  }, [formData]);

  useEffect(() => {
    if (selectedPlan) {
      getCouponList();
    }
  }, [selectedPlan]);

  useEffect(() => {
    if (couponList.length > 0) {
      const possibleCoupons = couponList.filter((c) => c.is_possible);

      if (possibleCoupons.length === 0) {
        return;
      }

      const specialCoupon = possibleCoupons.find(
        (c) => c.name === '[조선멤버십 한정] 2개월 연장 쿠폰',
      );

      if (specialCoupon) {
        setMaxDiscountCoupon(specialCoupon);
        setSelectedCoupon(specialCoupon);
        return; // 여기서 바로 종료
      }

      const sorted = possibleCoupons.sort((a, b) => {
        return a.payment_price - b.payment_price;
      });

      setMaxDiscountCoupon(sorted[0]);
      setSelectedCoupon(sorted[0]);
    }
  }, [couponList]);

  const discountPrice = (price: number) => {
    return selectedPlan.plan_prc - price;
  };

  const finalPrice = selectedCoupon
    ? selectedCoupon.payment_price
    : selectedPlan.plan_prc;

  return (
    <PageContainer>
      <PageTop text="요금제 결제" hasSearch={false} />
      <Container>
        <PaymentDetail>
          <PageTitle>요금제 정보</PageTitle>
          <Section>
            <PriceDiv>
              <SectionTitle>결제 금액</SectionTitle>
              <Price>{selectedPlan.plan_prc.toLocaleString('ko-KR')}원</Price>
              <MembershipTitle>
                {selectedPlan.name}
                {selectedPlan.plan_name === '전국 썸머페스타 특전' &&
                  ' 썸머페스타'}
              </MembershipTitle>
            </PriceDiv>

            <PaymentDetailDiv>
              <PaymentDetailRow>
                <PaymentDetailTitle>상품 금액</PaymentDetailTitle>
                <div>
                  <Data>
                    {isDiscount
                      ? `${(selectedPlan.plan_prc * 2).toLocaleString('ko-KR')}원`
                      : `${selectedPlan.plan_prc.toLocaleString('ko-KR')}원`}
                  </Data>
                </div>
              </PaymentDetailRow>
              {isDiscount && (
                <PaymentDetailRow>
                  <PaymentDetailTitle>
                    {' '}
                    {selectedPlan.name.includes('바른NPL')
                      ? '바른NPL 50% 할인'
                      : selectedPlan.name.includes('얼리버드')
                        ? '얼리버드 50% 할인'
                        : selectedPlan.name.includes('공인중개사')
                          ? '공인중개사 50% 할인'
                          : selectedPlan.plan_name.includes('썸머페스타')
                            ? '썸머페스타 50% 할인'
                            : '50% 특별 할인'}
                  </PaymentDetailTitle>
                  <SaleColumn>
                    <Data>
                      {isDiscount
                        ? `-${selectedPlan.plan_prc.toLocaleString('ko-KR')}원`
                        : '0원'}
                    </Data>
                  </SaleColumn>
                </PaymentDetailRow>
              )}
              {selectedCoupon && (
                <PaymentDetailRow>
                  <PaymentDetailTitle>{selectedCoupon.name}</PaymentDetailTitle>
                  {!selectedCoupon.name.includes('연장') && (
                    <Data>{`-${discountPrice(selectedCoupon.payment_price).toLocaleString('ko-KR')}원`}</Data>
                  )}
                </PaymentDetailRow>
              )}
              <s.GrayLine />
              <PaymentDetailRow>
                <FinalPriceTitle>최종 결제금액</FinalPriceTitle>
                <FinalPrice>{finalPrice.toLocaleString('ko-KR')}원</FinalPrice>
              </PaymentDetailRow>
            </PaymentDetailDiv>
            <PaymentDetailDiv>
              <DateSectionText bold>요금제 적용기간</DateSectionText>
              <DateSectionText>{`${formattedStart} ~ ${formattedEnd}`}</DateSectionText>
            </PaymentDetailDiv>
          </Section>
        </PaymentDetail>

        <PaymentDetail>
          <PageTitle>결제 수단</PageTitle>
          <Section>
            <PaymentButtonWrapper>
              <PaymentMethodButton
                $selected={paymentType === 'CARD'}
                onClick={() => setPaymentType('CARD')}
              >
                <img
                  src={`/assets/images/pay-icon/card${paymentType === 'CARD' ? '-active' : ''}.svg`}
                  alt=""
                />
                신용카드
              </PaymentMethodButton>

              <PaymentMethodButton
                $selected={paymentType === 'BANK'}
                onClick={() => setPaymentType('BANK')}
              >
                <img
                  src={`/assets/images/pay-icon/coin${paymentType === 'BANK' ? '-active' : ''}.svg`}
                  alt=""
                />
                계좌이체
              </PaymentMethodButton>

              <PaymentMethodButton
                $selected={paymentType === 'VBANK'}
                onClick={() => setPaymentType('VBANK')}
              >
                <img
                  src={`/assets/images/pay-icon/bankbook${paymentType === 'VBANK' ? '-active' : ''}.svg`}
                  alt=""
                />
                무통장 입금
              </PaymentMethodButton>
            </PaymentButtonWrapper>
          </Section>
        </PaymentDetail>

        <PaymentDetail>
          <PageTitle>
            <TitleWrapper>
              <span>쿠폰</span>
              {selectedCoupon &&
                maxDiscountCoupon &&
                maxDiscountCoupon.coupon_history_id ===
                  selectedCoupon.coupon_history_id && (
                  <MaxDiscountBadge>최대 혜택 적용중</MaxDiscountBadge>
                )}
            </TitleWrapper>
            <CouponCount>{couponTotalCount}장 보유</CouponCount>
          </PageTitle>
          <Section>
            <CouponSectionWrapper>
              <CouponButton
                onClick={() => {
                  if (!couponTotalCount) {
                    return;
                  }
                  setIsCouponModalOpen(true);
                }}
              >
                <CouponButtonTextArea>
                  {selectedCoupon ? (
                    <>
                      <CouponButtonPercent>
                        {selectedCoupon.name}
                      </CouponButtonPercent>
                      <CouponButtonTitle>적용</CouponButtonTitle>
                    </>
                  ) : maxDiscountCoupon ? (
                    <CouponButtonTitle>선택된 쿠폰이 없어요</CouponButtonTitle>
                  ) : (
                    <CouponButtonTitle>
                      사용 가능한 쿠폰이 없어요
                    </CouponButtonTitle>
                  )}
                </CouponButtonTextArea>
                <img src="/assets/images/arrow/black_arrow_up_20.svg" alt="" />
              </CouponButton>
              {selectedCoupon && (
                <SelectCouponDescription>
                  {selectedCoupon?.description}
                </SelectCouponDescription>
              )}
            </CouponSectionWrapper>
          </Section>
        </PaymentDetail>

        <Inner>
          <Section>
            <CautionTitle>요금제 구매 유의사항</CautionTitle>
            <CautionContentGray>
              ※ 현재 이용 중인 요금제와{' '}
              <CautionContentBold>동일</CautionContentBold> 상품 결제시
              <br />
              <CautionContent>
                이용일 종료 후 요금제 시작, 이용일 종료 후 열람권 제공
              </CautionContent>
            </CautionContentGray>
            <CautionContentGray>
              ※ 현재 이용 중인 요금제와{' '}
              <CautionContentBold>다른</CautionContentBold> 상품 결제시
              <br />
              <CautionContent>
                요금제 즉시 시작, 열람권 즉시 지급
              </CautionContent>
            </CautionContentGray>
          </Section>
          <div ref={buttonRef} style={{ height: '10px' }} />
          <ButtonBox fixed={isFixed}>
            <ConfirmButton onClick={() => handlePayment(paymentType)}>
              {finalPrice.toLocaleString('ko-KR')}원 결제하기
            </ConfirmButton>
          </ButtonBox>
        </Inner>
      </Container>
      <Footer />
      {isCouponModalOpen && (
        <CouponModal
          couponList={couponList}
          selectedCoupon={selectedCoupon}
          setSelectedCoupon={setSelectedCoupon}
          originPrice={selectedPlan.plan_prc}
          onClose={() => setIsCouponModalOpen(false)}
        />
      )}
      {formData && (
        <div>
          <form
            method="POST"
            acceptCharset="euc-kr"
            action={formData.url}
            ref={formRef}
            style={{ display: 'none' }}
          >
            {Object.entries(formData).map(([key, value]) => {
              return (
                <input
                  key={key}
                  type="text"
                  name={key}
                  value={value}
                  readOnly
                />
              );
            })}
          </form>
        </div>
      )}
    </PageContainer>
  );
};

export default PaymentMethod;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
  gap: 24px;
  background-color: #f3f5f7;
`;

const PaymentDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PageTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  color: #222;
`;

const Section = styled.div`
  width: 100%;
  padding: 20px 20px 16px;
  border-radius: 20px;
  border: 1px solid #e1e2e4;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PriceDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #222222;
`;

const Price = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const MembershipTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const PaymentDiv = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid #e5e8ea;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
`;

const PaymentButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MaxDiscountBadge = styled.div`
  display: flex;
  padding: 1px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: rgba(0, 138, 255, 0.06);

  color: #008aff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const CouponCount = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CouponSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CouponButton = styled.button`
  display: flex;
  padding: 16px 14px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;

  &:active {
    background: rgba(2, 32, 71, 0.05);
  }

  & > img {
    transform: rotate(90deg);
  }
`;

const CouponButtonTextArea = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
`;

const CouponButtonPercent = styled.div`
  color: #008aff;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const CouponButtonTitle = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const SelectCouponDescription = styled.div`
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const PaymentDetailDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 20px;
  border-radius: 16px;
  background-color: #f7f9fa;
`;

const PaymentDetailRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const PaymentDetailTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const FinalPriceTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const FinalPrice = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const DateSectionText = styled.div<{ bold?: boolean }>`
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? '700' : '500')};
  color: #222222;
`;

const Data = styled.div<{ isDiscount?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  color: ${({ isDiscount }) => (isDiscount ? '#616161' : '#222222')};
  text-decoration: ${({ isDiscount }) =>
    isDiscount ? 'line-through' : 'none'};
`;

const PaymentMethodDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PaymentMethodRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const PaymentMethodButton = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  user-select: none;
  width: 100%;
  gap: 8px;
  border-radius: 8px;
  padding: 16px 14px;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  border: 1px solid ${({ $selected }) => ($selected ? '#008AFF' : '#E1E2E4')};
  background-color: ${({ $selected }) =>
    $selected ? '#008AFF0F' : 'transparent'};
  color: ${({ $selected }) => ($selected ? '#008AFF' : '#222222')};

  font-weight: ${({ $selected }) => ($selected ? 700 : 500)};
  font-size: 15px;
  line-height: 145%;
  text-align: center;

  &:hover {
    background-color: #f7f8fc;
  }
`;
const SaleColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 4px;
`;

const Sale = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #ff5500;
`;

const Caution = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 8px;
  width: 100%;
`;

const CautionTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #616161;
`;

const CautionContent = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #222;
  display: inline;
`;

const CautionContentGray = styled(CautionContent)`
  color: #616161;
`;

const CautionContentBold = styled(CautionContent)`
  font-weight: 700;
`;

const ButtonBox = styled.div<{ fixed: boolean }>`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'relative')};
  bottom: ${({ fixed }) => (fixed ? '0' : 'auto')};
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ fixed }) => (fixed ? '24px 16px' : '0')};
  height: 94px;
  background: ${({ fixed }) =>
    fixed
      ? 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 65%, rgba(255,255,255,0) 100%)'
      : 'transparent'};
`;

const ConfirmButton = styled.div`
  width: 100%;
  padding: 14px 28px;
  border-radius: 8px;
  background-color: #008aff;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  text-align: center;
  color: #fff;

  &:active {
    background-color: #2272eb;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
`;
